import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';

import D1 from '../images/dashboard.png';
import D2 from '../images/adds.png';
import D3 from '../images/following.png';
import D4 from '../images/subscribe.png';
import D5 from '../images/Inactive.svg';
import Logout from '../images/logout.svg';
import settingImg from '../images/setting-inactive.png';
import planHistoryInactiveImg from '../images/plan-history-inactive.png';
import affiliateInactiveImg from '../images/affiliate-inactive.png';

import axios from '../api/axios';


import google_chrome_gray from '../images/chromenew.png';

function UserDashboardSidebar() {
    const token = JSON.parse(localStorage.getItem('token'));

    const navigate = useNavigate();
    const location = useLocation();


    const user = JSON.parse(localStorage.getItem('user_name'));
    const firstInitial = user?.charAt(0)?.toUpperCase() || '?';
    const email = user?.email || 'Welcome';

    const [isActive, setIsActive] = useState(() => window.innerWidth >= 768);

    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const contentWrapper = document.querySelector('.content-wrapper');
        if (isActive && contentWrapper) {
            contentWrapper.classList.add('margin-applied');
        }
    }, [isActive]);



    const togglePopup = () => {
        setShowPopup(prev => !prev);
    };

    const handlePopupOption = (option) => {
        setShowPopup(false);
        if (option === 'settings') {
            navigate('/settings');
        } else if (option === 'logout') {
            handleLogout();
        }
    };

    const toggleSidebar = () => {
        setIsActive((prev) => !prev);
        const contentWrapper = document.querySelector('.content-wrapper');
        if (contentWrapper) {
            contentWrapper.classList.toggle('margin-applied');
        }
    };

    const getActiveClass = (path) => location.pathname === path ? 'active' : '';

    /*  const handleLogout = () => {
         localStorage.removeItem('user');
         navigate('/login');
     }; */
    const handleLogout = () => {
        localStorage.clear();
        localStorage.removeItem('user');
        logout();

    };

    const logout = () => {
        //  setLoader(true);

        const config = {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        };

        const bodyParameters = {
            id: 10
        };
        axios
            //  .get("/api/v1/get-profile", {},{ headers: {"Authorization" : `Bearer ${token}`} })
            .post("/user/logout", bodyParameters, config)
            .then((res) => {
                console.log('res.result');
                console.log(res.data.result);
                navigate('/login');
                //   setLoader(false);
            })
            .catch((err) => {
                //   setLoader(false);
            });
    };


    return (
        <>
            <button
                className="toggle-sidebar-btn"
                onClick={toggleSidebar}
                aria-label="Toggle Sidebar"
            >
                ☰
            </button>

            <div
                className={`sidebar-content position-fixed sidebar ${isActive ? 'active' : 'collapsed'
                    }`}
                id="sidebar"
            >
                <div className="list-group rounded-0 sidebar-left">
                    <a href="/dashboard" className={`sidebar-item ${getActiveClass('/dashboard')}`}>
                        <img src={D1} alt="Dashboard" className="sidebarIcon" />
                        <span className="sidebarLabel">Dashboard</span>
                    </a>
                    <a href="/my-ads" className={`sidebar-item ${getActiveClass('/my-ads')}`}>
                        <img src={D2} alt="My Ads" className="sidebarIcon" />
                        <span className="sidebarLabel">My Ads</span>
                    </a>
                    <a href="/following" className={`sidebar-item ${getActiveClass('/following')}`}>
                        <img src={D3} alt="Following" className="sidebarIcon" />
                        <span className="sidebarLabel">Following</span>
                    </a>
                    <a href="/subscribe" className={`sidebar-item ${getActiveClass('/subscribe')}`}>
                        <img src={D4} alt="Subscribe" className="sidebarIcon" />
                        <span className="sidebarLabel">Subscribe</span>
                    </a>
                    <a
                        href="https://chromewebstore.google.com/detail/spyder-ads-v10/acgjmlhlkokkgomeaignoaebahennfbp"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`sidebar-item ${getActiveClass('/chrome')}`}
                    >
                        <img src={google_chrome_gray} alt="Chrome Extension" className="sidebarIcon" />
                        <span className="sidebarLabel">Chrome Ext.</span>
                    </a>
                    <a
                        href="https://spyderads.circle.so/join?invitation_token=23cf6e06d817872e77152dacd29efb01561686db-9fc2e1c5-d66c-419a-809a-aa0c19953cd0"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`sidebar-item ${getActiveClass('/circle')}`}
                    >
                        <img src={D5} alt="Circle Community" className="sidebarIcon" />
                        <span className="sidebarLabel">Community</span>
                    </a>
                    {/* <a
                        href="#"
                        onClick={handleLogout}
                        className={`sidebar-item logout ${getActiveClass('/logout')}`}
                    >
                        <img src={Logout} alt="Logout" className="sidebarIcon" />
                        <span>Logout</span>
                    </a> */}
                    <div className="sidebar-footer">
                        <div className="footer-menu">
                            
                            <a target='_blank' href="/contact-us" className={`sidebar-item ${getActiveClass('/contact-us')}`}>
                                <img src={D5} alt="Affiliate" className="sidebarIcon" />
                                <span className="sidebarLabel">Contact us</span>
                            </a>
                            <a target='_blank' href="https://spyderads.firstpromoter.com/" className={`sidebar-item ${getActiveClass('/affiliate')}`}>
                                <img src={affiliateInactiveImg} alt="Affiliate" className="sidebarIcon" />
                                <span className="sidebarLabel">Affiliate</span>
                            </a>
                            <a href="/plan-history" className={`sidebar-item ${getActiveClass('/plan-history')}`}>
                                <img src={planHistoryInactiveImg} alt="Affiliate" className="sidebarIcon" />
                                <span className="sidebarLabel">Plan History</span>
                            </a>
                            <a href="/edit-profile" className={`sidebar-item ${getActiveClass('/edit-profile')}`}>
                                <img src={settingImg} alt="Affiliate" className="sidebarIcon" />
                                <span className="sidebarLabel">Setting</span>
                            </a>
                            <a onClick={handleLogout} className={`sidebar-item ${getActiveClass('/affiliate')}`}>
                                <img src={Logout} alt="Logout" className="sidebarIcon" />
                                <span className="sidebarLabel">Logout</span>
                            </a>

                        </div>
                        <div className="sidebar-settings" >
                            <div className="avatar-circle">{firstInitial}</div>
                            <span>{email}</span>
                        </div>

                        {showPopup && (
                            <div className="popup-menu">
                                <a className="dropdown-item" target='_blank' href="https://spyderads.firstpromoter.com/">Affiliate</a>
                                <a className={`dropdown-item ${getActiveClass('/plan-history')}`} href="/plan-history">Plan History</a>
                                <a className="dropdown-item" href="/edit-profile">Settings</a>
                                {/* <a className="dropdown-item" onClick={handleLogout} href="#">Logout</a> */}
                                <div onClick={() => handlePopupOption('settings')}>Settings</div>
                                <div onClick={() => handlePopupOption('logout')}>Logout</div>
                            </div>
                        )}
                    </div>
                </div>


            </div>
        </>
    );
}

export default UserDashboardSidebar;
